// WPS-025 · Canvas Editor host page · loads a card and mounts CanvasCardEditor.
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { cardsApi } from '../../services/api';
import CanvasCardEditor from './CanvasCardEditor';
import { ArrowLeft } from 'lucide-react';

const CanvasEditorPage = () => {
  const { cardId } = useParams();
  const navigate = useNavigate();
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('user_token')) { navigate('/login'); return; }
    (async () => {
      setLoading(true);
      const r = await cardsApi.get(cardId);
      setCard(r);
      setLoading(false);
    })();
  }, [cardId, navigate]);

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
      <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '12px', color: '#64748b' }}>Loading card…</div>
    </div>;
  }
  if (!card) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '16px', fontWeight: 700 }}>Card not found</div>
        <button onClick={() => navigate('/dashboard')} style={{ marginTop: '12px', padding: '8px 16px', background: '#01579b', color: '#fff', border: 'none', cursor: 'pointer' }}>Back to Dashboard</button>
      </div>
    </div>;
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <div style={{ background: '#0a0a0a', color: '#ffffff', padding: '14px 20px' }}>
        <div style={{ maxWidth: '1240px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => navigate('/dashboard')} style={{ background: 'transparent', border: 'none', color: '#c9a961', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            <ArrowLeft className="h-4 w-4" /> Back
          </button>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '10px', fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.2em', color: '#c9a961' }}>
              CANVAS EDITOR · WPS-025
            </div>
            <div style={{ fontSize: '16px', fontWeight: 700 }}>{card.companyName || 'Untitled card'}</div>
          </div>
          <div style={{ fontSize: '10px', fontFamily: 'JetBrains Mono, monospace', color: '#94a3b8', letterSpacing: '0.1em' }}>
            mode: {card.designMode || 'template'}
          </div>
        </div>
      </div>
      <div style={{ maxWidth: '1240px', margin: '20px auto', padding: '0 16px' }}>
        <CanvasCardEditor cardId={card.id} initialLayout={card.canvasLayout} />
      </div>
    </div>
  );
};

export default CanvasEditorPage;
